// extracted by mini-css-extract-plugin
export default {"modal-logic-change-confirmation-body":"ModalLogicChangeConfirmation_modal-logic-change-confirmation-body__awDYq"};